/**
 * @author      joseph.murphy@zumper.com (murph)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { useToken } from '@chakra-ui/react'
import React from 'react'

import { IconProps } from '../../types'

export interface VerifyShield extends Omit<IconProps, 'fill'> {
  fillCheck?: string
  fillShield?: string
}

export const VerifyShield = ({ size = 20, fillCheck, fillShield, ...rest }: VerifyShield) => {
  const [gray900, gray100] = useToken('colors', ['gray.900', 'gray.100'])

  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        clipRule="evenodd"
        d="M10.0927 3.02734C10.2091 3.02734 10.3546 3.08203 10.471 3.10937L15.943 5.29687C16.5833 5.57031 17.0781 6.14453 17.0781 6.85546C17.049 9.58984 15.8556 14.539 10.8494 16.8085C10.3546 17.0273 9.80161 17.0273 9.3068 16.8085C4.30058 14.539 3.10723 9.58984 3.07812 6.85546C3.07812 6.14453 3.57293 5.57031 4.21326 5.29687L9.68518 3.10937C9.80161 3.08203 9.94714 3.02734 10.0927 3.02734Z"
        fill={fillShield ?? gray900}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13.5721 6.53588C13.9816 6.8527 14.0568 7.44151 13.74 7.85104L9.87185 12.851C9.70538 13.0662 9.45363 13.1985 9.18197 13.2135C8.91031 13.2284 8.64555 13.1247 8.45642 12.9291L6.52236 10.9291C6.16243 10.5569 6.17238 9.96339 6.54458 9.60346C6.91678 9.24353 7.51029 9.25348 7.87022 9.62568L9.05147 10.8472L12.2569 6.70374C12.5738 6.29422 13.1626 6.21906 13.5721 6.53588Z"
        fill={fillCheck ?? gray100}
        fillRule="evenodd"
      />
    </svg>
  )
}
